import classnames from 'classnames'

import './tooltip.scss'


const Tooltip = ({children, className, ...otherProps}) => <div {...otherProps} className={classnames('core tooltip', className)} role='tooltip'>{children}</div>

export default Tooltip
